import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import './IntroSectionAdminCloud.css';

const IntroSectionAdminCloud3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to Admin Cloud
  const adminCloudStats = [
    {
      value: '24/7',
      label: 'Surveillance continue',
      translationKey: 'adminCloud.stats.monitoring',
      labelTranslationKey: 'adminCloud.stats.monitoringLabel'
    },
    {
      value: '99.9%',
      label: 'Disponibilité garantie',
      translationKey: 'adminCloud.stats.uptime',
      labelTranslationKey: 'adminCloud.stats.uptimeLabel'
    },
    {
      value: '100%',
      label: 'Sécurité renforcée',
      translationKey: 'adminCloud.stats.security',
      labelTranslationKey: 'adminCloud.stats.securityLabel'
    },
    {
      value: '∞',
      label: 'Évolutivité assurée',
      translationKey: 'adminCloud.stats.scalability',
      labelTranslationKey: 'adminCloud.stats.scalabilityLabel'
    }
  ];

  return (
    <div className="intro-section-home intro-section-admin-cloud">
      <div className="intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('adminCloud.introSection.commitment', 'Notre engagement')}</h2>
        </div>
      </div>

      <FeaturedSectionStats
        title={t('adminCloud.stats.title', 'Confiez-nous votre infrastructure cloud pour une gestion professionnelle et sécurisée.')}
        subtitle={t('adminCloud.stats.subtitle', 'Votre organisation bénéficie d\'un pilotage clair par un Service Delivery Manager, d\'une transparence totale via des rapports réguliers et d\'une amélioration continue orientée résultats pour aligner l\'IT sur vos priorités métier.')}
        titleTranslationKey="adminCloud.stats.title"
        subtitleTranslationKey="adminCloud.stats.subtitle"
        stats={adminCloudStats}
        showChart={false}
      />
    </div>
  );
};

export default IntroSectionAdminCloud3;
